// Minimal i18n store mirroring the React app's i18next setup.
//
// Like React (src/admin/i18n.js), translations are a single flat namespace of
// snake_case key -> string, one map per language in LANGUAGES. The active
// language is persisted in the `language` cookie (same name/values React uses).
// Missing keys fall back to English, then to the raw key — matching i18next's
// fallbackLng: "en" behaviour, since the ported DE map is incomplete.
//
// Strings keep i18next-style {{var}} placeholders; t(key, vars) substitutes them.
import { en, de, es, pt } from "./resources.js";
import { readCookie, writeCookie } from "@bitcashier/shared/core/cookies.js";

export const i18n = $state({ lang: "en" });

const DICTS = { en, de, es, pt };

// Language picker options, each labelled in its own language.
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
];

const supported = (lang) => (Object.hasOwn(DICTS, lang) ? lang : "en");

export function initI18n() {
  i18n.lang = supported(readCookie("language"));
}

export function setLang(lang) {
  i18n.lang = supported(lang);
  writeCookie("language", i18n.lang);
}

export function t(key, vars) {
  // Read i18n.lang so this call re-runs reactively when the language changes.
  const lang = i18n.lang;
  let str = DICTS[lang]?.[key] ?? en[key] ?? key;
  if (vars) {
    for (const [name, value] of Object.entries(vars)) {
      str = str.replaceAll(`{{${name}}}`, String(value));
    }
  }
  return str;
}
